<template>
  <div class="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="w-full max-w-md">
      <div class="text-center mb-8">
        <h2 class="text-3xl font-bold tracking-tight text-gray-900">
          Mot de passe oublié
        </h2>
        <p class="mt-2 text-sm text-gray-600">
          Entrez votre email pour réinitialiser votre mot de passe
        </p>
      </div>

      <div class="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
        <form @submit.prevent="handleSubmit" class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Email
            </label>
            <p class="mt-1 text-sm text-gray-500">
              Nous vous enverrons un lien de réinitialisation
            </p>
            <input
              id="email"
              v-model="email"
              type="email"
              required
              autocomplete="email"
              class="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:border-zebu-orange focus:ring focus:ring-zebu-orange/20 text-sm"
              placeholder="vous@exemple.com"
            />
          </div>

          <div>
            <button
              type="submit"
              :disabled="loading"
              class="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-zebu-orange hover:bg-zebu-orange/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zebu-orange disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-300"
            >
              <svg
                v-if="loading"
                class="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              {{ loading ? 'Envoi en cours...' : 'Réinitialiser le mot de passe' }}
            </button>
          </div>

          <div v-if="message" 
              class="rounded-lg p-4"
              :class="{'bg-green-50': !error, 'bg-red-50': error}">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg v-if="!error" class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <svg v-else class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm" :class="{'text-green-700': !error, 'text-red-700': error}">{{ message }}</p>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <router-link
              to="/login"
              class="font-medium text-zebu-orange hover:text-zebu-orange/90 text-sm"
            >
              Retour à la connexion
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth.store'

const authStore = useAuthStore()
const email = ref('')
const loading = ref(false)
const message = ref('')
const error = ref(false)

const handleSubmit = async () => {
  loading.value = true
  message.value = ''
  error.value = false

  try {
    await authStore.forgotPassword(email.value, 'member-area')
    message.value = 'Un email de réinitialisation vous a été envoyé'
    error.value = false
    email.value = ''
  } catch (err) {
    message.value = err.response?.data?.message || 'Une erreur est survenue'
    error.value = true
  } finally {
    loading.value = false
  }
}
</script> 